import { render, staticRenderFns } from "./lawReview.vue?vue&type=template&id=54f522a8"
import script from "./lawReview.vue?vue&type=script&lang=js"
export * from "./lawReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f522a8')) {
      api.createRecord('54f522a8', component.options)
    } else {
      api.reload('54f522a8', component.options)
    }
    module.hot.accept("./lawReview.vue?vue&type=template&id=54f522a8", function () {
      api.rerender('54f522a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/law/review/lawReview.vue"
export default component.exports